import React from "react";
import {Box} from "@mui/material";
import QrCode2OutlinedIcon from "@mui/icons-material/QrCode2Outlined";
import {useTranslation} from "react-i18next";
import QRCodeSVG from "react-qr-code";
import {qrCodeBlockSx} from "./qrCodeBlockStyles";
import type {PrintoutQrCodeNodeAttrs} from "./printoutQrCodeOptions";

interface Props {
    attrs: Required<PrintoutQrCodeNodeAttrs>;
}

const QR_CODE_QUIET_ZONE_MM = 2;

const QR_CODE_ERROR_CORRECTION = "M";

const QrCodeView = ({attrs}: Props) => {
    const {t} = useTranslation();
    const {url, sizeMm} = attrs;
    const frameStyle = {
        height: `${sizeMm}mm`,
        padding: `${QR_CODE_QUIET_ZONE_MM}mm`,
        width: `${sizeMm}mm`,
    };

    return (
        <Box className="printout-qr-code-block" sx={qrCodeBlockSx}>
            <div
                className={url ? "printout-qr-code-frame" : "printout-qr-code-frame printout-qr-code-frame-empty"}
                style={url ? {...frameStyle, backgroundColor: "#ffffff"} : frameStyle}
            >
                {url ? (
                    <QRCodeSVG level={QR_CODE_ERROR_CORRECTION} value={url}/>
                ) : (
                    <div className="printout-qr-code-placeholder" contentEditable={false}>
                        <QrCode2OutlinedIcon fontSize="small"/>
                        <span className="printout-qr-code-placeholder-hint">{t("Add URL")}</span>
                    </div>
                )}
            </div>
        </Box>
    );
};

export default QrCodeView;
